<template>
  <atomic-link class="nav-support" href="/support">
    <icon-placeholder>
      <atomic-icon id="live-support" />
    </icon-placeholder>
  </atomic-link>
</template>

<style src="~/assets/styles/components/nav/support.scss" lang="scss" />
